// extracted by mini-css-extract-plugin
export default {"parent":"LuruUserListDisplay_parent__YBYTV","pointer":"LuruUserListDisplay_pointer__iVkqb"};